import { Pipe, PipeTransform } from '@angular/core';

import { KPI } from '../../@core/api';

@Pipe({
    name: 'ngxAssetLocation',
    standalone: true
})
export class AssetLocationPipe implements PipeTransform {

  transform(asset: KPI.MappedAsset): string {
    if (asset) {
      return asset.perimeters.map((perimeter) => perimeter.name).join(' > ');
    }
  }
}
